import classes from './notesLoading.module.scss';
import { Skeleton } from 'primereact/skeleton';

const NotesLoadingSkeleton = () => {
  return (
    <div className={classes.tabSkeletonSkeleton}>
      <div className={classes.tabSkeletonTable}>
        <Skeleton height="45rem"></Skeleton>
      </div>
    </div>
  );
};

export default NotesLoadingSkeleton;
